const fileExtension = (filename, allowed) => {
    const extension = filename.split('.').pop();

    if (allowed) {
        if (allowed.incudes(extension)) {
            return extension;
        } else {
            throw new Error(`Extension not allowed: ${extension}`);
        }
    } else {
        return extension;
    }

}

export default fileExtension;
